import React from "react";

function SvgIcMapPoi128(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M14.026 15.009h1.899l-.934-2.802-.965 2.802zM16.79 18l-.546-1.637H13.59L13.034 18h-2.036l2.571-7h2.781l2.603 7h-2.162zm.122 5v5h-4v-5h4zM5 8h17.29c.402 0 .793.121 1.123.345l.138.103 5.538 4.5a2 2 0 01.123 2.996l-.123.108-5.538 4.5a2 2 0 01-1.09.44L22.29 21H5c-1.05 0-1.918-.82-1.994-1.851L3 19v-9c0-1.05.82-1.918 1.851-1.994L5 8h17.29zm9.913-4a2 2 0 012 2h-4a2 2 0 012-2z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi128;
